// extracted by mini-css-extract-plugin
module.exports = {"gbcolor":"linear-gradient(30deg,#7d76ef,#d63f8c)"};